export enum ProjectSource {
  /** playsmart */
  PS = 'ps',
  /** 通用模板 */
  GM = 'gm',
  /** 定制模板 */
  DM = 'dm',
}

export enum EngineType {
  PlaySmart = 1,
  Phaser = 2,
  Layabox = 3,
  Egret = 4,
  ThreeJS = 5,
  MWEndCard = 6,
  PlaySmart2 = 7,
  Cocos = 8,
  Unknown = 99,
}
